<template>
    <div>
        <Header @show-contact="showContact" :active="1" :title="'荟镜XR1'"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner_pc" src="../../assets/image/product/product_banner.jpg"></img>
            <img class="banner_m" src="../../assets/image/product/xr_banner_m.jpg"></img>
        </div>
        <div class="detail-xr">
            <img src="../../assets/image/product/xr1_detail.jpg"></img>
            <h1>荟镜XR1头显产品介绍</h1>
        </div>
        <div class="advantage-xr">
            <img src="../../assets/image/product/background.png"></img>
            <h1>产品优势</h1>
            <div class="first">
                <div class="high">
                    <div class="pdd">
                        <p>高PPD</p>
                        <p>更高的像素密度，图像更加清晰和细腻</p>
                        <img src="../../assets/image/product/xr_ppd.jpg">
                    </div>
                    <div class="resolution">
                        <p>高分辨率</p>
                        <p>呈现极佳的画质和细节表现</p>
                        <img src="../../assets/image/product/xr_resolution.jpg">
                    </div>
                </div>
                <div class="dof">
                    <p>大视场角</p>
                    <p>更宽广的视野，视觉感知更为自然</p>
                    <img src="../../assets/image/product/xr_fov.jpg">
                </div>
                <div class="dof">
                    <p>6DOF</p>
                    <p>扩大运动识别范围 更加灵活自由</p>
                    <img src="../../assets/image/product/xr_6dof.jpg">
                </div>
            </div>
            <div class="second">
                <div class="txt">
                    <p>局部调光技术</p>
                    <p>增强黑暗区域，同时保留鲜艳的色彩</p>
                    <img src="../../assets/image/product/xr_light.jpg">
                </div>
                <div class="txt">
                    <p>QLED+Mini LED屏幕</p>
                    <p>彩色色域和黑色都呈现出更好效果</p>
                    <img src="../../assets/image/product/xr_qled.jpg">
                </div>
                <div class="txt">
                    <p></p>
                    <p>Inside-out定位功能</p>
                    <img src="../../assets/image/product/xr_location.jpg">
                </div>
                <div class="txt">
                    <p>Brain-warp</p>
                    <p>技术降低延迟、滞后，保证画面的流畅和平滑</p>
                    <img src="../../assets/image/product/xr_shadow.jpg">
                </div>
            </div>
            <h2>产品配置</h2>
            <div class="third">
                <div class="product-item">
                    <img src="../../assets/image/product/xr_hd.jpg">
                    <p>8K高分辨率</p>
                </div>
                <div class="product-item">
                    <img src="../../assets/image/product/xr_n.jpg">
                    <p>72Hz/90Hz/120Hz 三种模式</p>
                </div>
                <div class="product-item">
                    <img src="../../assets/image/product/xr_sj.jpg">
                    <p>140度大视场角</p>
                </div>
                <div class="product-item">
                    <img src="../../assets/image/product/xr_35ppd.jpg">
                    <p>35 PPD</p>
                </div>
            </div>
        </div>
        <div class="advantage_m">
            <img src="../../assets/image/product/vr_m_1.jpg">
            <img src="../../assets/image/product/vr_m_2.jpg">
            <img src="../../assets/image/product/vr_m_3.jpg">
            <img src="../../assets/image/product/vr_m_4.jpg">
            <img src="../../assets/image/product/xr_m_1.jpg">
            <img src="../../assets/image/product/vr_m_6.jpg">
        </div>
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import Footer from '../../components/Footer.vue'
import Header from '../../components/Head.vue'
import Contact from '../../components/Contact.vue'
import Email from '../../components/Email.vue'
export default {
    data() {
        return {
            isContactVisible: false
        }
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        }
    },
}
</script>
<style scoped>
@import '../../assets/css/product/xr.css';
</style>